export const MINIMUM_DOWNLOAD_SPEED_MBITS = 1.5;
export const RECOMMENDED_DOWNLOAD_SPEED_MBITS = 5;
export const MAXIMUM_LATENCY_MS = 150;
export const RECOMMENDED_LATENCY_MS = 100;
export const REFRESH_FREQUENCY_MS = 3000;
export const CONNECTION_CHANGE_DEBOUNCE_MS = 30000;
export const CONNECTION_QUALITY_LOG_PREFIX = 'NovaConnectionQualityService';
